import React from "react";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import Navbar from "../../Layouts/Navbar/Navbar";
import FileRepoRenderer from "./FileRepoRenderer";

const FileRepoSection = () => {
  return (
    <section className="main_section">
      <div className="d_flex">
        <HeaderModes />
      </div>
      <div className="d_flex">
        <Navbar />
        <FileRepoRenderer />
      </div>
    </section>
  );
};

export default FileRepoSection;
